(function () {
  var LIMIT = 4;
  var PRODUCT_FETCH_CAP = 3;

  function shopifyRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    if (window.theme && window.theme.routes && window.theme.routes.root_url) {
      return window.theme.routes.root_url;
    }
    return '/';
  }

  function formatMoney(cents) {
    var amount = Number(cents) || 0;
    var currency = window.themeVendor && window.themeVendor.themeCurrency;
    var moneyFormat = window.theme && window.theme.moneyFormat;
    var formatted;

    if (currency && moneyFormat) {
      formatted = currency.formatMoney(amount, moneyFormat);
      if (window.theme.settings && window.theme.settings.currency_code_enable && window.theme.currencyCode) {
        formatted += ' ' + window.theme.currencyCode;
      }
      return formatted;
    }

    return (amount / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function sizedImageUrl(src, width) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;

    try {
      var url = new URL(src, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (error) {
      var separator = src.indexOf('?') === -1 ? '?' : '&';
      return src + separator + 'width=' + width;
    }
  }

  function productImage(product, width) {
    var src = '';
    if (product.featured_media && product.featured_media.preview_image && product.featured_media.preview_image.src) {
      src = product.featured_media.preview_image.src;
    } else if (product.featured_image) {
      src = product.featured_image;
    } else if (product.images && product.images[0]) {
      src = product.images[0];
    }
    return sizedImageUrl(src, width || 408);
  }

  function availableVariant(product) {
    var variants = product.variants || [];
    var available = variants.filter(function (variant) {
      return variant.available;
    });
    return available[0] || variants[0] || null;
  }

  function recommendationsJsonUrl(productId, intent) {
    var route = window.theme && window.theme.routes && window.theme.routes.product_recommendations_url;
    if (!route) route = shopifyRoot() + 'recommendations/products';
    route = String(route).replace(/\.json$/i, '').replace(/\/?$/, '') + '.json';
    return (
      route +
      '?product_id=' + encodeURIComponent(productId) +
      '&limit=' + LIMIT +
      '&intent=' + encodeURIComponent(intent)
    );
  }

  async function fetchRecommendations(productId, intent) {
    var response = await fetch(recommendationsJsonUrl(productId, intent));
    if (!response.ok) return [];
    var data = await response.json();
    return data.products || [];
  }

  async function fetchRecommendationGroups(productIds, intent) {
    return Promise.all(
      productIds.slice(0, PRODUCT_FETCH_CAP).map(function (id) {
        return fetchRecommendations(id, intent).catch(function () {
          return [];
        });
      })
    );
  }

  function uniqueProducts(groups, cartProductIds) {
    var seen = {};
    var products = [];

    groups.forEach(function (group) {
      group.forEach(function (product) {
        var id = Number(product.id);
        if (!id || seen[id] || cartProductIds[id] || product.available === false) return;
        seen[id] = true;
        products.push(product);
      });
    });

    return products.slice(0, LIMIT);
  }

  function saleBadgeHtml(product, root) {
    var price = Number(product.price);
    var compare = Number(product.compare_at_price);
    if (!compare || compare === price) return '';

    var saleFrom = compare > price ? compare : price;
    var saleTo = compare > price ? price : compare;
    var type = (root && root.getAttribute('data-badge-sale-type')) || (window.theme && window.theme.settings && window.theme.settings.badge_sale_type) || 'percentage';
    var showDiscount = !root || root.getAttribute('data-badge-sale-discount') !== 'false';
    var saleLabel = (root && root.getAttribute('data-sale-label')) || (window.theme && window.theme.strings && window.theme.strings.sale) || 'Sale';
    var saveLabel = (root && root.getAttribute('data-save-label')) || 'Save';
    var amount;

    if (type === 'percentage') {
      amount = Math.floor(((saleFrom - saleTo) / saleFrom) * 100) + '%';
    } else {
      amount = formatMoney(saleFrom - saleTo);
    }

    return (
      '<span class="product__badge product__badge--sale">' +
        escapeHtml(showDiscount ? saveLabel + ' ' + amount : saleLabel) +
      '</span>'
    );
  }

  function unitPriceHtml(variant) {
    if (!variant || variant.unit_price == null || variant.unit_price === '') return '';

    var measurement = variant.unit_price_measurement || {};
    var refValue = measurement.reference_value && Number(measurement.reference_value) !== 1 ? measurement.reference_value : '';
    var refUnit = measurement.reference_unit || '';

    return (
      '<p class="line__price">' +
        '<span>' +
          formatMoney(variant.unit_price) +
          ' <span aria-hidden="true">/</span>' +
          refValue + refUnit +
        '</span>' +
      '</p>'
    );
  }

  function renderCard(product, root) {
    var variant = availableVariant(product);
    var image = productImage(product, 180);
    var image2x = productImage(product, 360);
    var url = product.url || (shopifyRoot() + 'products/' + product.handle);
    var price = variant ? variant.price : product.price;
    var compare = Number(product.compare_at_price) || Number(variant && variant.compare_at_price) || 0;
    var onSale = compare && Number(compare) !== Number(price);
    var firstPrice = onSale
      ? '<del class="line__price-compare">' + formatMoney(compare) + '</del><mark>' + formatMoney(price) + '</mark>'
      : formatMoney(price);

    var addLabel = (window.theme && window.theme.strings && window.theme.strings.addToCart) || 'Add';
    var canAdd = variant && variant.available !== false;
    var addButton = canAdd
      ? '<button type="button" class="cart-drawer-rec__add" data-cart-rec-add="' + variant.id + '" aria-label="' + escapeHtml(addLabel) + '">' +
          '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="icon-theme icon-theme-stroke icon-set-classic-cart" viewBox="0 0 24 24"><path d="M20.5 16.5H5.715l1.082-4.195-2.126-7.456L3.715 1.5H1.5m5.22 10h11.702l3.002-6.13s.428-.87-.745-.87H4.5m2 16.986a1 1 0 1 0 2 .028 1 1 0 0 0-2-.028Zm11 .014a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z"/></svg>' +
        '</button>'
      : '';

    return (
      '<div class="cart__items__row">' +
        '<div class="cart__items__grid">' +
          '<div class="cart__items__image' + (image ? '' : ' product-no-image') + '">' +
            '<a href="' + escapeHtml(url) + '">' +
              (image
                ? '<img class="cart__items__img" src="' + escapeHtml(image) + '" srcset="' + escapeHtml(image) + ' 180w, ' + escapeHtml(image2x) + ' 360w" sizes="163px" alt="' + escapeHtml(product.title) + '" width="163" height="150" loading="lazy">'
                : '') +
            '</a>' +
            addButton +
          '</div>' +
          '<div class="cart__items__title">' +
            '<p><a href="' + escapeHtml(url) + '">' + escapeHtml(product.title) + '</a></p>' +
          '</div>' +
          '<div class="cart__items__price">' +
            '<p class="line__price">' + firstPrice + '</p>' +
            unitPriceHtml(variant) +
            saleBadgeHtml(product, root) +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function hideRecommendations(root, list) {
    root.hidden = true;
    if (list) list.innerHTML = '';
  }

  async function loadRecommendations(cart, root) {
    var list = root.querySelector('[data-cart-recommendations-list]');
    if (!list) return;

    var items = (cart && cart.items) || [];
    if (!items.length) {
      hideRecommendations(root, list);
      return;
    }

    var cartProductIds = {};
    var uniqueIds = [];
    items.forEach(function (item) {
      var id = Number(item.product_id);
      if (!id || cartProductIds[id]) return;
      cartProductIds[id] = true;
      uniqueIds.push(id);
    });

    var complementary = await fetchRecommendationGroups(uniqueIds, 'complementary');
    var products = uniqueProducts(complementary, cartProductIds);

    if (!products.length && uniqueIds.length) {
      var related = await fetchRecommendationGroups(uniqueIds, 'related');
      products = uniqueProducts(related, cartProductIds);
    }

    if (!products.length) {
      hideRecommendations(root, list);
      return;
    }

    list.innerHTML = products.map(function (product) {
      return renderCard(product, root);
    }).join('');
    root.hidden = false;
  }

  async function addToCart(variantId, button) {
    button.disabled = true;
    try {
      var response = await fetch(shopifyRoot() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });

      if (!response.ok) throw new Error('Could not add to cart');

      var cartResponse = await fetch(shopifyRoot() + 'cart.js');
      if (!cartResponse.ok) throw new Error('Could not load cart');
      var cart = await cartResponse.json();

      document.dispatchEvent(
        new CustomEvent('theme:cart:change', {
          bubbles: true,
          detail: { cart: cart },
        })
      );
      document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    } catch (error) {
      button.disabled = false;
    }
  }

  function init(root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var requestId = 0;

    function schedule(cart) {
      var id = ++requestId;
      loadRecommendations(cart, root).catch(function () {
        if (id === requestId) hideRecommendations(root, root.querySelector('[data-cart-recommendations-list]'));
      });
    }

    document.addEventListener('theme:cart:change', function (event) {
      var cart = event.detail && event.detail.cart;
      if (!cart) return;
      schedule(cart);
    });

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-cart-rec-add]');
      if (!button) return;
      event.preventDefault();
      addToCart(button.getAttribute('data-cart-rec-add'), button);
    });

    fetch(shopifyRoot() + 'cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(schedule)
      .catch(function () {});
  }

  function initAll() {
    document.querySelectorAll('[data-cart-recommendations]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
